import React, { useEffect, useState } from "react";
import { ClipboardList, Plus } from "lucide-react";
import { Page, Card, Pill, PrimaryButton } from "../components/UI";
import api from "../lib/api";

export default function Forms() {
  const [data, setData] = useState({ prebuilt: [], custom: [] });

  useEffect(() => {
    api.get("/forms/library").then(({ data }) => setData(data));
  }, []);

  const grouped = data.prebuilt.reduce((acc, f) => {
    if (!acc[f.category]) acc[f.category] = [];
    acc[f.category].push(f);
    return acc;
  }, {});

  return (
    <Page title="Forms Library" subtitle="Pre-built clinical forms — assessments, consents, billing.">
      {Object.entries(grouped).map(([cat, forms], idx) => (
        <Card key={cat} delay={0.05 + idx*0.05} className="mb-4" testid={`forms-${cat}`}>
          <h3 className="font-serif text-xl mb-3 capitalize">{cat}</h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3">
            {forms.map(f => (
              <div key={f.id} className="p-4 rounded-xl flex items-start gap-3" style={{ background: "var(--mf-muted)" }} data-testid={`form-${f.id}`}>
                <ClipboardList className="w-5 h-5 mt-1 shrink-0" style={{ color: "var(--mf-primary)" }} />
                <div className="flex-1">
                  <div className="font-medium text-sm">{f.name}</div>
                  {f.items && <div className="text-xs" style={{ color: "var(--mf-text-muted)" }}>{f.items} items</div>}
                </div>
                <Pill variant="primary">Use</Pill>
              </div>
            ))}
          </div>
        </Card>
      ))}
      {data.custom.length > 0 && (
        <Card delay={0.3}>
          <h3 className="font-serif text-xl mb-3">Custom Forms</h3>
          <div className="space-y-2">
            {data.custom.map(f => (
              <div key={f.id} className="p-3 rounded-xl flex items-center justify-between" style={{ background: "var(--mf-muted)" }}>
                <div>
                  <div className="font-medium text-sm">{f.name}</div>
                  <div className="text-xs" style={{ color: "var(--mf-text-muted)" }}>{f.fields?.length || 0} fields</div>
                </div>
                <Pill>{f.category}</Pill>
              </div>
            ))}
          </div>
        </Card>
      )}
    </Page>
  );
}
